import { render, staticRenderFns } from "./SpecialTitle.vue?vue&type=template&id=8dc8fa56&scoped=true&"
import script from "./SpecialTitle.vue?vue&type=script&lang=js&"
export * from "./SpecialTitle.vue?vue&type=script&lang=js&"
import style0 from "./SpecialTitle.vue?vue&type=style&index=0&id=8dc8fa56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc8fa56",
  null
  
)

export default component.exports